import { observer } from 'mobx-react-lite'
import { type MessageGroup } from '@/features/messaging/ConversationViewModel'
import { type MessageViewModel } from '@/features/messaging/MessageViewModel'
import {
  Bubble,
  BubbleMessageGroup,
} from '@/features/messaging/components/ConversationView/Messages/List/BubbleMessageGroup'
import { MessageContentContainer } from '@/features/messaging/components/ConversationView/Messages/List/MessageContentContainer'
import { messageEditProps } from '@/features/messaging/components/ConversationView/Messages/List/message-bindings'
import { match } from '@/utils/pattern-match-util'

export interface BubbleMessageGroupContainerProps {
  group: MessageGroup
}

export const BubbleMessageGroupContainer = observer(
  function BubbleMessageGroupContainer({
    group,
  }: BubbleMessageGroupContainerProps) {
    const mine = group.sender.isCurrentUser
    return (
      <BubbleMessageGroup
        showDateLine={group.showDateLine}
        timestamp={group.timestamp}
        mine={mine}
        senderDisplayName={group.sender.displayName}
        senderAvatar={group.sender}
        tagLabel={match(group.tag, {
          None: () => null,
          Admin: () => 'Admin',
          Assistant: () => 'Assistant',
          System: () => 'System',
        })}
      >
        {group.messages.map((messageVm) => (
          <BubbleContainer
            key={messageVm.message.id}
            messageVm={messageVm}
            mine={mine}
          />
        ))}
      </BubbleMessageGroup>
    )
  },
)

interface BubbleContainerProps {
  messageVm: MessageViewModel
  mine: boolean
}

const BubbleContainer = observer(function BubbleContainer({
  messageVm,
  mine,
}: BubbleContainerProps) {
  return (
    <Bubble
      mine={mine}
      isNote={messageVm.isNote}
      isText={messageVm.isText}
      onInView={messageVm.markAsRead}
      edit={messageEditProps(messageVm)}
      content={
        <MessageContentContainer
          testId="message-content"
          messageVm={messageVm}
          bubble
        />
      }
    />
  )
})
